import {SourcingType} from '../../../hooks/useSourcingType';

/**
 * The origin country filter applies only to classifieds: `all_auctions` has no origin country.
 */
export const isOriginCountryFilterVisible = (
  sourcingType: SourcingType,
  isOriginCountryFilterEnabled: boolean
): boolean => isOriginCountryFilterEnabled && sourcingType === SourcingType.CLASSIFIEDS;
